import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import {
  getPaymentChannelV2,
  PaymentChannelType,
} from 'features/Payment/services/paymentGatewayAdmin'
import {
  getPaymentList,
  GetPaymentListRequestType,
} from 'features/Payment/services/paymentDashboard'
import { RootStateType } from 'store'
import { SLICE_NAME, setPaymentChannel, setIsLoading, setPaymentList, setQuery } from './slice'

export const fetchInternalPaymentChannel = createAsyncThunk(
  `${SLICE_NAME}/fetchInternalPaymentChannel`,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await getPaymentChannelV2()
      let newPaymentChannel: PaymentChannelType[] = []
      res.data.data.payment_channel_v2.forEach((el) => {
        newPaymentChannel = [...newPaymentChannel, ...el.payment_channel]
      })

      dispatch(setPaymentChannel(newPaymentChannel))
      return newPaymentChannel
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

const validateParamsValue = (
  key: keyof GetPaymentListRequestType['params'],
  value: string | number | null | undefined,
) =>
  value
    ? {
        [key]: value,
      }
    : {}

export const fetchPaymentList = createAsyncThunk(
  `${SLICE_NAME}/fetchPaymentList`,
  async (_, { rejectWithValue, dispatch, getState }) => {
    dispatch(setIsLoading(true))
    try {
      const {
        paymentDashboardList: { query, selectedPaymentChannel },
      } = getState() as RootStateType
      const {
        data: { data },
      } = await getPaymentList({
        params: {
          ...validateParamsValue('limit', query.limit),
          ...validateParamsValue('payment_status', query.status.value),
          ...validateParamsValue('payment_method', selectedPaymentChannel?.code),
          ...validateParamsValue('end_date', query.end_date ? query.end_date.valueOf() : ''),
          ...validateParamsValue('start_date', query.start_date ? query.start_date.valueOf() : ''),
          ...validateParamsValue('order_id', query.orderChildID.trim()),
          ...validateParamsValue('cursor', query.cursor),
        },
      })

      dispatch(setPaymentList(data.payment_list))
      dispatch(setIsLoading(false))
      dispatch(
        setQuery({
          value: {
            prev_cursor: data.pagination_response.prev_cursor,
            next_cursor: data.pagination_response.next_cursor,
          },
        }),
      )
      return data
    } catch (err) {
      callErrorMsg(err)

      dispatch(setIsLoading(false))
      return rejectWithValue(err)
    }
  },
)
